export function massiveSelect(e) {
  document.querySelectorAll('.table .body .ds-checkbox').forEach(el => {
    el.checked = e.target.checked;
  });

  e.target.classList.remove('partial');

  // Footer
  const footer = document.querySelector('.table .footer');
  const selected = document.querySelector('.table .footer p span');
  const rows = document.querySelectorAll('.table .body .row');

  if (e.target.checked) {
    footer.style.display = 'flex';
    selected.textContent = rows.length;
  } else {
    footer.style.display = 'none';
  }
}

export function partialSelect(e) {
  const headCheckbox = document.querySelector('.table .head .ds-checkbox');
  const rows = document.querySelectorAll('.table .body .ds-checkbox');
  const rowsChecked = document.querySelectorAll('.table .body .ds-checkbox:checked');
  const footer = document.querySelector('.table .footer');

  if (e.target.checked) {
    headCheckbox.checked = true;

    if ( rows.length != rowsChecked.length ) {
      headCheckbox.classList.add('partial');
    } else {
      headCheckbox.classList.remove('partial');
    }

    footer.style.display = 'flex';
  } else {
    if ( rowsChecked.length >= 1 ) {
      headCheckbox.classList.add('partial');
      footer.style.display = 'flex';
    } else {
      headCheckbox.checked = false;
      headCheckbox.classList.remove('partial');
      footer.style.display = 'none';
    }
  }

  // Footer
  const selected = document.querySelector('.table .footer p span');

  selected.textContent = rowsChecked.length;
}